import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import PersonalAreaInvoicesBlockData from '../../../Models/Content/PersonalAreaInvoicesBlockData';
import InvoicesComponentBlock from './InvoicesComponentBlock'
import './PersonalAreaInvoicesBlock.scss';
import { isMobile } from "react-device-detect";

export default class PersonalAreaInvoicesBlock extends EpiComponent<PersonalAreaInvoicesBlockData>
{
    public render() : ReactNode | ReactNodeArray | null
    {
        let cssClasses : Array<string> = ['personal-area-invoices-block'];
        if(isMobile) cssClasses.push("isMobile");

        return  (
            <div className={cssClasses.join(' ').trim()}>
                <InvoicesComponentBlock isMobile={isMobile} context={this.getContext()} iContent={this.props.data} />
            </div>
        )
    }
}
